import proj4 from 'proj4'

// 是否将经纬度显示成度的形 如果为否 则为度分秒

var latlngFormatDFM = true

function formatLatlngDFM(latlng) {
    var lat = latlng.lat;
    var lng = latlng.lng;

    function convertToDMS(coord) {
        var absCoord = Math.abs(coord);
        var deg = Math.floor(absCoord);
        var min = (absCoord - deg) * 60;
        var sec = (min - Math.floor(min)) * 60;
        return `${deg}° ${Math.floor(min)}' ${sec.toFixed(1)}"`;
    }
    var formattedLat = (lat >= 0 ? ' N' : ' S') + convertToDMS(lat)
    var formattedLng = (lng >= 0 ? ' E' : ' W') + convertToDMS(lng)

    return `${formattedLat},${formattedLng}`;
}

function formatLatlngDecimal(latlng) {
    let lat = latlng.lat;
    let lng = latlng.lng;

    // 格式化为度保留小数点后6位
    var formattedDecimal = {
        lat: latlng.lat.toFixed(6),
        lng: latlng.lng.toFixed(6)
    }
    var formattedLat = (lat >= 0 ? ' N' : ' S') + formattedDecimal.lat
    var formattedLng = (lng >= 0 ? ' E' : ' W') + formattedDecimal.lng
    return `${formattedLat},${formattedLng}`
}

/**
 * 获取矩形的两个边长 
 * @param {矩形} rectangle 
 * @returns 
 */
function getWidthAndHigh(rectangle) {

    let latlons = rectangle.getLatLngs()[0];
    let p1 = L.latLng(latlons[0]);
    let p2 = L.latLng(latlons[1]);
    let p3 = L.latLng(latlons[2]);

    let d1 = p1.distanceTo(p2);
    let d2 = p1.distanceTo(p3);

    return [d1, d2];
}

/**
 * 输出长度
 * @param {长度} length 
 * @returns 
 */
function formatLength(length) {
    let output = ''
    if (length > 100) {
        output = (Math.round(length / 1000 * 100) / 100) + ' ' + ' km';
    } else {
        output = (Math.round(length * 100) / 100) + ' ' + 'm';
    }
    return output;
}


function getArea(rectangle) {
    let ds = getWidthAndHigh(rectangle);
    let area = ds[0] * ds[1];
    return area;
}


function formatArea(rectangle) {
    let output = ''
    let area = getArea(rectangle)
    if (area > 10000) {
        output = (Math.round(area / 1000000 * 100) / 100) + ' ' + 'km<sup>2</sup>';
    } else
        output = (Math.round(area * 100) / 100) + ' ' + 'm<sup>2</sup>';

    //var mu = area / 666.67;
    // var gq = area / 10000;
    // return output + '( ' + mu.toFixed(2) + '亩 / ' + gq.toFixed(2) + "公顷 )";
    return output
}


function changeLatlngFormat() {
    latlngFormatDFM = !latlngFormatDFM
}
function formatLatlng(latlng) {
    if (!latlng) {
        return ''
    }

    if (latlngFormatDFM)
        return formatLatlngDFM(latlng)
    else
        return formatLatlngDecimal(latlng)
}


function toDFM(degree) {
    // body...度向度分秒转换
    degree = Math.abs(degree);
    var v1 = Math.floor(degree);
    var v2 = Math.floor((degree - v1) * 60);
    var v3 = Math.round(((degree - v1) * 3000) % 60);
    return v1 + "°" + v2 + "'" + v3 + '"';
}

function isLatLngValid(latlng) {
    if (!latlng || typeof latlng !== 'object' || !('lat' in latlng) || !('lng' in latlng)) {
        return false;
    }

    const lat = latlng.lat;
    const lng = latlng.lng;

    if (typeof lat !== 'number' || typeof lng !== 'number') {
        return false;
    }

    if (lat < -90 || lat > 90) {
        return false;
    }

    if (lng < -180 || lng > 180) {
        return false;
    }

    return true;
}

/**
 * 
 * @param {度分秒格式的经纬c度} latlngDMS 
 * @returns 
 */
function isLatLngDMSValid(latlngDMS) {
    if (!latlngDMS || typeof latlngDMS !== 'object' ||
        !('lat' in latlngDMS) || !('lng' in latlngDMS)) {
        return false;
    }

    const lat = latlngDMS.lat;
    const lng = latlngDMS.lng;

    if (!lat || typeof lat !== 'object' ||
        !('d' in lat) || !('m' in lat) || !('s' in lat)) {
        return false;
    }

    if (!lng || typeof lng !== 'object' ||
        !('d' in lng) || !('m' in lng) || !('s' in lng)) {
        return false;
    }

    const latDegrees = lat.d;
    const latMinutes = lat.m;
    const latSeconds = lat.s;

    const lngDegrees = lng.d;
    const lngMinutes = lng.m;
    const lngSeconds = lng.s;

    if (typeof latDegrees !== 'number' || typeof latMinutes !== 'number' || typeof latSeconds !== 'number' ||
        typeof lngDegrees !== 'number' || typeof lngMinutes !== 'number' || typeof lngSeconds !== 'number') {
        return false;
    }

    if (latDegrees < -90 || latDegrees > 90 ||
        lngDegrees < -180 || lngDegrees > 180) {
        return false;
    }

    if (latMinutes < 0 || latMinutes > 59 ||
        lngMinutes < 0 || lngMinutes > 59) {
        return false;
    }

    if (latSeconds < 0 || latSeconds > 59 ||
        lngSeconds < 0 || lngSeconds > 59) {
        return false;
    }

    return true;
}

function convertLatLngDMStoLatLng(latlngDMS) {
    if (!isLatLngDMSValid(latlngDMS)) {
        return null
    }

    const latDegrees = latlngDMS.lat.d;
    const latMinutes = latlngDMS.lat.m;
    const latSeconds = latlngDMS.lat.s;

    const lngDegrees = latlngDMS.lng.d;
    const lngMinutes = latlngDMS.lng.m;
    const lngSeconds = latlngDMS.lng.s;

    const latInDecimal = latDegrees + (latMinutes / 60) + (latSeconds / 3600);
    const lngInDecimal = lngDegrees + (lngMinutes / 60) + (lngSeconds / 3600);

    return {
        lat: latInDecimal,
        lng: lngInDecimal
    };
}

function isXYValid(xy) {
    if (!xy || typeof xy !== 'object' || !('x' in xy) || !('y' in xy)) {
        return false;
    }

    const x = xy.x;
    const y = xy.y;

    if (typeof x !== 'number' || typeof y !== 'number') {
        return false;
    }

    // 检查x是否为7位数值
    if (x.toString().length !== 7) {
        return false;
    }

    // 检查y是否为8位数值
    if (y.toString().length !== 8) {
        return false;
    }

    return true;
}

/**
 * 计算中央经线
 * @param {带号} bandNumber 
 * @param {类型‘3’或者'6'} bandType 
 * @returns 
 */
function calculatelon0(bandNumber, bandType) {
    if (bandType === '6') {
        return 6 * bandNumber - 3;
    } else if (bandType === '3') {
        return 3 * bandNumber;
    }
}

function CGCS2000ToWGS84(xy, bandType) {
    const yStr = xy.y.toString()
    var number = parseInt(yStr.slice(0, 2))
    var realY = parseInt(yStr.substring(2))
    //计算出中央经线
    var lon0 = calculatelon0(number, bandType)
    // 定义CGCS2000高斯投影坐标系
    var cgcs2000GaussDef = `+proj=tmerc +lat_0=0 +lon_0=${lon0} +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs`
    // 定义WGS84地理坐标系
    var wgs84Def = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";

    var latlng = proj4(cgcs2000GaussDef, wgs84Def, [realY, xy.x])

    return {
        lat: latlng[1],
        lng: latlng[0]
    };
}

/**
 * WGS84经纬度转CGCS2000高斯投影坐标
 * @param {Object} latlng 包含lat,lng属性的对象
 * @param {String} bandType 投影带类型 '3'或'6'
 * @returns {Object} 包含x,y属性的CGCS2000投影坐标对象
 */
function WGS84ToCGCS2000(latlng, bandType) {
    if (!isLatLngValid(latlng)) {
        throw new Error('Invalid WGS84 coordinates');
    }

    // 计算中央经线
    const lon = latlng.lng;
    const bandNumber = bandType === '6' ?
        Math.floor((lon + 6) / 6) :
        Math.floor(lon / 3);
    const lon0 = calculatelon0(bandNumber, bandType);

    // 定义WGS84地理坐标系
    const wgs84Def = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
    // 定义CGCS2000高斯投影坐标系
    const cgcs2000GaussDef = `+proj=tmerc +lat_0=0 +lon_0=${lon0} +k=1 +x_0=500000 +y_0=0 +ellps=GRS80 +units=m +no_defs`;

    // 执行坐标转换
    const [x, y] = proj4(wgs84Def, cgcs2000GaussDef, [latlng.lng, latlng.lat]);

    // 添加带号
    const yWithBand = bandNumber * 1000000 + y;

    return {
        x: Math.round(x),
        y: Math.round(y)
    };
}




// 经纬度转瓦片编号
function lon2tile(lon, zoom) {
    return (Math.floor((lon + 180) / 360 * Math.pow(2, zoom)));
}

function lat2tile(lat, zoom) {
    return (Math.floor((1 - Math.log(Math.tan(lat * Math.PI / 180) + 1 / Math.cos(lat * Math.PI / 180)) / Math.PI) / 2 * Math.pow(2, zoom)));
}

//计算当前点所在的瓦片号
function latlon2tile(latlon, zoom) {
    let t1 = lat2tile(latlon.lat, zoom);
    let t2 = lon2tile(latlon.lng, zoom);
    return [t1, t2];
}

//计算两个点这间的瓦片数量
function calcTotalTileSize(latlon1, latlon2, zoom) {
    let tile1 = latlon2tile(latlon1, zoom);
    let tile2 = latlon2tile(latlon2, zoom);
    let x = Math.abs(tile2[0] - tile1[0]) + 1;
    let y = Math.abs(tile2[1] - tile1[1]) + 1;
    return x * y;
}



function getPicResolution(leftTop, rightBottom, level) {
    let leftTopTile = latlon2tile(leftTop, level)
    let rightBottomTile = latlon2tile(rightBottom, level)
    let x = Math.abs(leftTopTile[0] - rightBottomTile[0]) + 1
    let y = Math.abs(leftTopTile[1] - rightBottomTile[1]) + 1
    return x * 256 + "*" + y * 256;
}




export default {
    formatArea,
    formatLength,
    getWidthAndHigh,
    changeLatlngFormat,
    formatLatlng,
    isLatLngValid,
    isLatLngDMSValid,
    convertLatLngDMStoLatLng,
    convertCGCS2000GaussToWGS84: CGCS2000ToWGS84,
    WGS84ToCGCS2000,
    isXYValid,
    calculatelon0,
    calcTotalTileSize,
    getPicResolution
}



// WEBPACK FOOTER //
// ./src/util/geoUtil.js